import { ToastNotifications } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { getFeatureFromCache } from '../../util/feature-cache'

/**
 * Hook to show toast notification for special order products when sale completed
 */
export const useSpecialOrderProductToast = () => {
  const t = useT()

  const specialOrderProductToast = (numOfSpecialOrderProducts: number) => {
    const ffSpecialOrder = getFeatureFromCache('inventory_special_orders')
    if (!ffSpecialOrder) return
    if (numOfSpecialOrderProducts < 1) return

    const message = t(
      '{numOfSpecialOrderProducts, plural, one {Special order product included in sale} other {Special order products included in sale}}',
      {
        numOfSpecialOrderProducts,
        _context: 'Toast notification for special order product',
      }
    )
    ToastNotifications.success(message)
  }

  return specialOrderProductToast
}
